module.exports = __webpack_public_path__ + "static/media/3dots.ebce6704.svg";